export const BACKEND_URL =
  process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || 'http://localhost:9000'

export const BACKEND_URL_ADMIN = `${BACKEND_URL}/admin`

export const BACKEND_URL_STORE = `${BACKEND_URL}/store`
